import script from "./PromocodeRemovedModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromocodeRemovedModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__